import { postImageData } from "../ClientConsumer";
import { AxiosResponse } from "axios";

const POST_IMAGE = "/media";

export function uploadImage(
    blob: Blob,
    abortControllerSignal?: AbortSignal,
): Promise<AxiosResponse<any, any>> {
    const formData = new FormData();
    formData.append("media", blob);
    return postImageData(POST_IMAGE, formData, {
        signal: abortControllerSignal,
    });
}
